// extracted by mini-css-extract-plugin
export default {"wrapperSp":"Spinner_style_wrapperSp__-nIyU","spinner1":"Spinner_style_spinner1__Mjhm6","spin":"Spinner_style_spin__P1ROs","rotate":"Spinner_style_rotate__KSsPr"};